import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function TransformationSection() {
  return <section className="py-24 px-4 bg-warm-gradient" data-id="element-260">
      <div className="max-w-4xl mx-auto text-center" data-id="element-261">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="bg-white p-10 md:p-16 rounded-[2rem] shadow-xl border border-white/50 relative" data-id="element-262">
          <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-terracotta text-white p-3 rounded-full shadow-lg" data-id="element-263">
            <Sparkles className="w-6 h-6" data-id="element-264" />
          </div>

          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brown mb-8" data-id="element-265">
            Imagina que tienes el manual.
          </h2>

          <div className="space-y-6 text-lg md:text-xl text-brown-light leading-relaxed text-left max-w-2xl mx-auto" data-id="element-266">
            <p data-id="element-267">
              Surge un desacuerdo sobre el sueño del bebé. Sientes esa tensión
              familiar en el pecho.
            </p>
            <p data-id="element-268">
              Pero en lugar de soltar una frase pasivo-agresiva o tragarte el
              enojo... dices:{' '}
              <span className="italic" data-id="element-269">
                "Usemos el sistema de 10 minutos esta noche"
              </span>
              .
            </p>
            <p data-id="element-270">Se sientan. Sacan la plantilla. Leen el guión (literalmente).</p>
            <p data-id="element-271">
              Sin culpas. Sin "tú siempre" ni "tú nunca". Solo hechos y
              acuerdos.
            </p>
            <p data-id="element-272">
              Diez minutos después, el tema está cerrado. Escrito. Pegado en la
              nevera. Y ustedes están en el sofá, viendo una serie, tomados de
              la mano.
            </p>
            <ul className="space-y-3 py-4" data-id="element-273">
              <li className="flex items-center gap-3 font-bold text-terracotta" data-id="element-274">
                <span className="w-2 h-2 bg-terracotta rounded-full" data-id="element-275"></span>
                Volvieron a ser un equipo.
              </li>
              <li className="flex items-center gap-3 font-bold text-terracotta" data-id="element-276">
                <span className="w-2 h-2 bg-terracotta rounded-full" data-id="element-277"></span>
                La casa volvió a tener paz.
              </li>
              <li className="flex items-center gap-3 font-bold text-terracotta" data-id="element-278">
                <span className="w-2 h-2 bg-terracotta rounded-full" data-id="element-279"></span>
                La crianza dejó de ser un campo de batalla.
              </li>
            </ul>
          </div>

          <div className="mt-10 pt-10 border-t border-gray-100" data-id="element-280">
            <p className="font-serif italic text-2xl text-brown" data-id="element-281">
              "Dejamos de pelear por la crianza cuando dejamos de improvisar las
              conversaciones."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}